import { Component } from '@angular/core';

@Component({
	selector: 'app-appointment-list-item-skeleton',
	templateUrl: './appointment-list-item-skeleton.component.html',
	styleUrls: ['./appointment-list-item-skeleton.component.scss'],
})
export class AppointmentListItemSkeletonComponent { }
